const SELECTED_COMPANY_ID = "selectedCompanyId";

export const setSelectedCompanyId = (companyId: string) =>
  localStorage.setItem(SELECTED_COMPANY_ID, companyId);
export const getSelectedCompanyId = () => {
  return localStorage.getItem(SELECTED_COMPANY_ID) || undefined;
};
export const removeSelectedCompanyId = () =>
  localStorage.removeItem(SELECTED_COMPANY_ID);
